// Common column span constants for consistent grid layouts
const GRID_CONSTANTS = {
  // Column spans (out of 24 total)
  COL_SPAN_NONE: -1,
  COL_SPAN_ONE_SIXTH: 4,
  COL_SPAN_ONE_FOURTH: 6,
  COL_SPAN_ONE_THIRD: 8,
  COL_SPAN_HALF: 12,
  COL_SPAN_TWO_THIRDS: 16,
  COL_SPAN_THREE_FOURTHS: 18,
  COL_SPAN_FULL: 24,

  // Common gutters
  DEFAULT_GUTTER: [24, 24] as [number, number],
  TIGHT_GUTTER: [16, 16] as [number, number],

  // Heights
  MIN_HEIGHT: 20
};

export const {
  COL_SPAN_NONE,
  COL_SPAN_ONE_SIXTH,
  COL_SPAN_ONE_FOURTH,
  COL_SPAN_ONE_THIRD,
  COL_SPAN_HALF,
  COL_SPAN_TWO_THIRDS,
  COL_SPAN_THREE_FOURTHS,
  COL_SPAN_FULL,
  DEFAULT_GUTTER,
  TIGHT_GUTTER,
  MIN_HEIGHT
} = GRID_CONSTANTS;
